import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import homeLogo from '../../assets/home-main.png';
import Particle from '../Particle';
import Type from './Type';
import myImg from '../../assets/avatar.png';
import Tilt from 'react-parallax-tilt';
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from 'react-icons/ai';
import { FaLinkedinIn, FaMobile } from 'react-icons/fa';
import { CgMail } from 'react-icons/cg';

const Home = () => {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{' '}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'm
                <strong className="main-name"> Vasanth Prabhakaran</strong>
              </h1>

              <div style={{ padding: 50, textAlign: 'left' }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: '450px' }}
              />
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col md={8} className="home-about-description">
              <h1 style={{ fontSize: '2.6em' }}>
                LET ME <span className="text-color"> INTRODUCE </span> MYSELF
              </h1>
              <p className="home-about-body">
                I have developed a passion for programming and have gained
                proficiency in languages such
                <i>
                  <b className="text-color"> Javascript and C#. 🤷‍♂️</b>
                </i>
                <br />
                <br />
                My interests lie in creating new &nbsp;
                <i>
                  <b className="text-color">Web Technologies and Products </b>{' '}
                  particularly in the areas{' '}
                  <b className="text-color">
                    App Development and Website Designing.
                  </b>
                </i>
                <br />
                <br />I enjoy utilizing my skills in{' '}
                <b className="text-color">Node.js, .NET</b> and
                <i>
                  <b className="text-color">
                    {' '}
                    Modern Javascript Library and Frameworks
                  </b>
                </i>
                &nbsp; like
                <i>
                  <b className="text-color"> React, Angular, Vue and NextJS</b>
                </i>
              </p>
              <p className="text-color">
                "Develop your career to achieve your aspirations and make your
                dreams a reality!"{' '}
              </p>
              <footer className="blockquote-footer">Vasanth</footer>
            </Col>
            <Col md={4} className="myAvatar">
              <Tilt>
                <img src={myImg} className="img-fluid" alt="avatar" />
              </Tilt>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="home-about-social">
              <h1>FIND ME ON</h1>
              <p>
                Feel free to <span className="text-color">connect </span>with me
              </p>
              <ul className="home-about-social-links">
                <li className="social-icons">
                  <a
                    href="tel:+91 8110822002"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaMobile />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="mailto:vasanthprabhakaran1999@gmail.com"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <CgMail />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://github.com/Vasanth1009"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://twitter.com/Vasanth10091999"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiOutlineTwitter />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/vasanthprabhakaran"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                {/* <li className="social-icons">
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
              </ul>
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
};

export default Home;
